<div *ngIf="item" class="row form-property  {{property?.styleClass ? property.styleClass : ''}}">
  <div
    class="col-lg-{{tooltip?10:12}}"
    [ngClass]="{'no-padding-right':tooltip}"
  >
    <span class="p-float-label">
      <p-multiSelect
        [appendTo]="'body'"
        id="{{name}}"
        [options]="options"
        (onChange)="change($event)"
        [ngModel]="value"
        [disabled]="readonly"
        [defaultLabel]="property.defaultLabel"
        [ngClass]="{'disabled':readonly, 'property-invalid':notValid}"
        class="ui-inputwrapper-focus ui-inputwrapper-focus"
        [style]="{'width': '100%'}"
        [maxSelectedLabels]="maxSelectedLabels"
        [selectedItemsLabel]="'{0} items selected'"
      >
      </p-multiSelect>
      <label class="gs-float-label {{property?.labelClass ? property.labelClass : ''}}" [ngClass]="{'error-color':notValid}">{{label}}</label>
      <span
        *ngIf="notValid"
        class="form-error"
        pTooltip="{{property.validationMessage}}"
        tooltipPosition="top"
      >
        <i
          class="fas fa-info-circle fa-2x form-valid-icon with-icon error-color"
        ></i>
      </span>
    </span>
  </div>
  <div *ngIf="tooltip" class="col-lg-2 property-tooltip">
    <span pTooltip="{{property.tooltip}}">
      <i class="fas fa-info-circle master-color"></i>
    </span>
  </div>
</div>
